import { render, staticRenderFns } from "./createTesk.vue?vue&type=template&id=dac6083a&"
import script from "./createTesk.vue?vue&type=script&lang=js&"
export * from "./createTesk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports